import { SubscriptionStatus } from "../enums/subscriptionEnums";

/** Subscription statuses that super admins may manually activate. */
export const PENDING_ACTIVATION_STATUSES: ReadonlySet<string> = new Set([
  SubscriptionStatus.PENDING,
]);

export function isPendingActivationStatus(status: string): boolean {
  return PENDING_ACTIVATION_STATUSES.has(status);
}
